import request from "@/utils/request";

export function getActivityList(params) {
  return request.get('/vote/activity/list', params, { login: false });
}

export function activityDetail(id,params) {
  return request.get(`/vote/activity/detail/${id}`,params, { login: false });
}
export function getActivityPlateList(id) {
  return request.get(`/vote/activity/plate/${id}`,{}, { login: false });
}
export function getActivityCategoryList(id) {
  return request.get(`/vote/activity/category/${id}`,{}, { login: false });
}
export function getActivitySchoolList(id) {
  return request.get(`/vote/activity/school/${id}`,{}, { login: false });
}

export function getWorksList(params) {
  return request.get(`/vote/works/list`,params, { login: false });
}
export function getWorksDetail(id,params) {
  return request.get(`/vote/works/detail/${id}`,params, { login: false });
}
export function worksSignUp(params) {
  return request.post(`/vote/works/sign`,params, { login: true });
}
export function worksSignCheck(params) {
  return request.post(`/vote/works/signCheck`,params, { login: true });
}
export function worksSignUpEdit(params) {
  return request.post(`/vote/works/signEdit`,params, { login: true });
}
export function getRankingList(params) {
  return request.get(`/vote/works/ranking`,params, { login: false });
}

export function setPreselection(params) {
  return request.post(`/vote/setPreselection`,params, { login: true });
}

export function getPreselection(params) {
  return request.post(`/vote/getPreselection`,params, { login: true });
}
export function setCache(params) {
  return request.post(`/vote/setCache`,params, { login: true });
}

export function getCache(params) {
  return request.post(`/vote/getCache`,params, { login: true });
}

export function submitCheck(params) {
  return request.post(`/vote/submitCheck`,params, { login: true });
}
export function submitCache(params) {
  return request.post(`/vote/submitCache`, params,{ login: true });
}
export function submit(params) {
  return request.post(`/vote/submit`,params, { login: true });
}
export function poster(id) {
  return request.post(`/vote/works/poster/${id}`,{}, { login: true });
}
